/** HTTP-Client für die API. Netzwerkfehler werden als NetworkError gemeldet. */
import { NetworkError } from './outbox.js';
import type { EntryChange, SyncResult } from '../shared/types.js';

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export interface RequestOpts {
  method?: string;
  body?: unknown;
  /** Service Worker soll nicht aus dem Cache antworten (network-first). */
  fresh?: boolean;
}

export async function api<T>(path: string, opts: RequestOpts = {}): Promise<T> {
  const headers: Record<string, string> = { 'X-ZE': '1' };
  if (opts.body !== undefined) headers['Content-Type'] = 'application/json';
  if (opts.fresh) headers['X-Fresh'] = '1';
  let res: Response;
  try {
    res = await fetch(`/api${path}`, {
      method: opts.method ?? 'GET',
      headers,
      credentials: 'same-origin',
      body: opts.body === undefined ? undefined : JSON.stringify(opts.body),
    });
  } catch {
    throw new NetworkError();
  }
  if (res.status === 504 && res.headers.get('X-Offline') === '1') throw new NetworkError();
  const data = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) {
    if (res.status === 401) window.dispatchEvent(new CustomEvent('ze:unauthorized'));
    throw new ApiError(res.status, data.error ?? `Fehler ${res.status}`);
  }
  return data;
}

export async function syncEntries(changes: EntryChange[]): Promise<SyncResult[]> {
  const r = await api<{ results: SyncResult[] }>('/sync', { method: 'POST', body: { entries: changes } });
  return r.results;
}
